export enum UtmParameters {
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_TERM = 'utm_term',
  UTM_CONTENT = 'utm_content',
  UTM_GCLID = 'gclid',
  UTM_FBLID = 'fbclid',
}
